import { useEffect, useState } from 'react';

import { MEDIUM_BREAKPOINT, MOBILE_BREAKPOINT } from 'styles/theme';

type ScreenSizes = {
    isMobileScreenSize: boolean;
    isMediumScreenSize: boolean;
};

export function useResponsiveScreenSizes(
    mobileMax = MOBILE_BREAKPOINT,
    mediumMax = MEDIUM_BREAKPOINT
): ScreenSizes {
    const [sizes, setSizes] = useState<ScreenSizes>(() => {
        if (typeof window === 'undefined') {
            return { isMobileScreenSize: false, isMediumScreenSize: false };
        }

        const width = window.innerWidth;
        return {
            isMobileScreenSize: width <= mobileMax,
            isMediumScreenSize: width <= mediumMax,
        };
    });

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const updateSizes = () => {
            const width = window.innerWidth;
            setSizes({
                isMobileScreenSize: width <= mobileMax,
                isMediumScreenSize: width <= mediumMax,
            });
        };

        updateSizes();

        window.addEventListener('resize', updateSizes);
        return () => window.removeEventListener('resize', updateSizes);
    }, [mobileMax, mediumMax]);

    return sizes;
}
